import { create } from 'zustand'
import api from '../services/api'

// Drives the numeric badge on the HR rail icon (PrimarySidebar): "how many
// upcoming interviews (now..+7d) are on vacancies I can see". Mirrors
// learningBadgeStore's poll-on-nav pattern — PrimarySidebar calls refresh()
// on every navigation, so a booked/cancelled interview updates the badge
// without a reload. Fail soft to 0 — an hr-module/API blip (or the module
// simply not being entitled) must never disturb the rail.
interface HrBadgeState {
  /** Upcoming interviews visible to the caller (server: now..+7d window). */
  upcomingCount: number
  refresh: () => Promise<void>
}

export const useHrBadgeStore = create<HrBadgeState>((set) => ({
  upcomingCount: 0,
  refresh: async () => {
    try {
      const { data } = await api.get('/hr/interviews/badge')
      set({ upcomingCount: typeof data?.count === 'number' ? data.count : 0 })
    } catch {
      set({ upcomingCount: 0 })
    }
  },
}))

/** Imperative refresh for non-component callers (e.g. after booking actions). */
export function refreshHrBadge(): void {
  void useHrBadgeStore.getState().refresh()
}
